
import { Link } from 'react-router-dom'
import { Collection, Bijoux } from '../pages/home.page'

export function HomeGridBlock(collection: Collection) {
    return (
        
        <div className="col-12 col-md-6 home-grid">
            <Link to={ "/collection/" + collection.shortName }>
            <img
                className="home-grid-img"
                src={composeImgURL(collection.folder, collection.coverImage)}
                style={{ objectPosition: collection.coverImagePosition === 'bottom' ? '50% 90%' : '50% 0' }}
            />
            <h1 className="home-grid-title">{collection.shortName.toUpperCase()}</h1>
            </Link>
        </div>

    )
}

export function HomeGridBlockBijoux(bijoux: Bijoux) {
    return (
        
        <div className="col-12 col-md-6 home-grid">
            <Link to={ "/bijoux"}>
            <img className="home-grid-img" src={composeImgURL(bijoux.folder, bijoux.coverImage)} />
            <h1 className="home-grid-title">{bijoux.shortName.toUpperCase()}</h1>
            </Link>
        </div>

    )
}

export function HomeGridBlockBridal() {
    return (
        
        <div className="col-12 col-md-6 home-grid">
            <Link to={ "/bridal"}>
            <img className="home-grid-img" src={composeImgURL('bridal', '1.jpg')} />
            <h1 className="home-grid-title">BRIDAL</h1>
            </Link>
        </div>

    )
}

export function HomeGridBlockCelebrities() {
    return (
        
        <div className="col-12 col-md-6 home-grid">
            <Link to={ "/celebrities"}>
            <img className="home-grid-img" src={composeImgURL('celebrities', '1.jpg')} />
            <h1 className="home-grid-title">CELEBRITIES</h1>
            </Link>
        </div>

    )
}

export const composeImgURL = (folder: string, image: string) => folder + '/' + image;